import { Button } from '@material-ui/core';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { Fade } from "react-awesome-reveal";
import Footer, { FooterPitch } from '../components/footer';
import { WaveFooter, WaveHeader } from '../components/wave';
import heroImage1 from '../public/hero-1.jpg';

const styles = {
    content: {
        padding: 64,
        marginLeft: 200,
    },
    infoTextContainer: {
        marginBottom: 32,
    },
}

interface AboutProps {
    verses: string[],
}
const About = (props: AboutProps): JSX.Element => {
    const [verse, setVerse] = useState("")

    useEffect(() => {
        setVerse(props.verses[Math.floor(Math.random() * props.verses.length)]);

    }, [props.verses])


    let landing = (<div className="leading-normal tracking-normal text-white gradient" style={{ fontFamily: "'Source Sans Pro', sans-serif" }}>
        <WaveHeader />
        <section className="bg-white border-b py-8">
            <div className="container max-w-5xl mx-auto m-8">
                <h1 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
                    Got questions?
                </h1>
                <div className="w-full mb-4">
                    <div className="h-1 mx-auto gradient w-128 opacity-25 my-0 py-0 rounded-t"></div>
                </div>

                <div className="flex justify-center">
                    <Link href="https://form.jotform.com/212434818241148" legacyBehavior><Button variant="contained" color="primary">We have answers!</Button></Link>.
                </div>
            </div>
        </section>
        <WaveFooter />
        <FooterPitch />
        <Footer />
    </div>
    );

    return landing;
    return (
        <div>
            <Fade direction="left">
                <Image src={heroImage1} alt="Hero"></Image>
                <h2>Keep your images safe</h2>
                <div>Aquinas has 99.999999999% (11 9&apos;s) of durability</div>
            </Fade>
        </div>
    );
}

// This also gets called at build time
export async function getStaticProps({ }) {
    // Pass post data to the page via props
    let verses = ["Children’s children are a crown to the aged, and parents are the pride of their children. -Proverbs 17:6", "But Jesus called them to him, saying, \"Let the children come to me, and do not hinder them, for the kingdom of God belongs to such as these.\" -Luke 18:16"]
    return { props: { verses } }
}

export default About
